const ImageSizePlaceholder = '_size_';

function formatImageUrl(imageUrl: string, size: string): string {
    return imageUrl.replace(ImageSizePlaceholder, size);
}

function defaultImageUrl(imageUrl: string): string {
    // '700' is one of the sizes PIM has provided (see complete list in ResponsiveProductImage.vue)
    return formatImageUrl(imageUrl, '700');
}

export default {
    formatImageUrl,
    defaultImageUrl
};
